import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
import { Tooltip } from "./Tooltip.js";
function RightText({
  children,
  tooltip
}) {
  return (tooltip == null ? void 0 : tooltip.length) ? /* @__PURE__ */ jsx(Tooltip, {
    content: tooltip,
    position: "top-right",
    children: (triggerProps) => /* @__PURE__ */ jsx(RightElementText, {
      ...triggerProps,
      children
    })
  }) : /* @__PURE__ */ jsx(RightElementText, {
    children
  });
}
const RightElementText = styled.div.withConfig({
  displayName: "RightElementText",
  componentId: "sc-1dqvib0-0"
})(["display:flex;justify-content:flex-end;align-items:center;color:", ";text-align:right;"], token.gray400);
export {
  RightElementText,
  RightText
};
//# sourceMappingURL=RightText.js.map
